import {
  EntityInput,
  isURLAbsolute,
  LinkProps,
  withTrailSlash,
} from "helpers/url";
import { UrlObject } from "url";

/* todo: refactor without EntityLinkProps */
export function navLinkHref(
  entity: EntityInput,
  region?: string,
  origin?: string
): LinkProps["href"] {
  if (isURLAbsolute(entity.href)) {
    return entity.href;
  }

  if (!entity.local && origin) {
    return navLinkAs(entity, region, origin);
  }

  const obj: Partial<UrlObject> = {
    pathname: entity.href,
  };

  if (region) {
    obj.query = { region };
  }

  if (entity.hash) {
    obj.hash = entity.hash;
  }

  return obj;
}

export function navLinkAs(
  entity: EntityInput,
  region?: string,
  origin?: string
): LinkProps["as"] {
  if (isURLAbsolute(entity.href)) {
    return entity.href;
  }

  let url = `${entity.local ? "" : origin}${withTrailSlash(entity.href)}${
    region ? `r_${region}/` : ""
  }`;
  if (entity.hash) {
    url += entity.hash;
  }
  return url;
}
